import { useState } from 'react';

import agent from '../../../../api/agent';
import { Static } from '../../../../static';
import { EtichettaValore } from '../../../../models/etichetta-valore';

type Props = {
	sportello: EtichettaValore;
};

type InfoRowProps = {
	iconSrc: string;
	label: string;
	value: string;
	className?: string;
};

const InfoRow = ({ iconSrc, label, value, className = '' }: InfoRowProps) => (
	<div className={`app-info-div ${className}`.trim()}>
		<img alt='' className='app-info-icon' src={iconSrc} />
		<div className='ms-2'>
			<span>{label}</span>
			<br />
			<span className='app-bold'>{value}</span>
		</div>
	</div>
);

type ReferenceDeskBodyProps = {
	sportello: EtichettaValore;
	onSOLClick: () => void;
	viewOnGoogleMaps: () => void;
	firstRowClassName?: string;
};

const ReferenceDeskBody = ({
	sportello,
	onSOLClick,
	viewOnGoogleMaps,
	firstRowClassName = '',
}: ReferenceDeskBodyProps) => (
	<>
		<InfoRow
			iconSrc='/images/veritas/invoice/MapsIcon.svg'
			label={sportello.Etichetta}
			value={sportello.Valore}
			className={firstRowClassName}
		/>

		<div className='app-info-div mt-4'>
			<img
				alt=''
				className='app-info-icon'
				src='/images/veritas/invoice/WorldIcon.svg'
			/>
			<div className='ms-2'>
				<span>SI ACCEDE ALLO SPORTELLO SOLO SU PRENOTAZIONE.</span>
				<br />
				<span>
					Puoi prenotare l’appuntamento sullo{' '}
					<a
						className='app-link'
						href={Static.urlVeritasSOL}
						target='_blank'
						rel='noopener noreferrer'
						onClick={onSOLClick}
					>
						Sportello Online Veritas
					</a>
				</span>
			</div>
		</div>

		<button
			type='button'
			className='btn app-btn-details mt-4'
			onClick={viewOnGoogleMaps}
			aria-label='Visualizza su Google Maps: Sportello più vicino'
		>
			<img
				alt=''
				className='app-icon-white-hover'
				src='/images/veritas/invoice/OnGoogleMapsIcon.svg'
			/>
			Visualizza su Google Maps
		</button>
	</>
);

const ReferenceDesk = ({ sportello }: Props) => {
	const [showDetails, setShowDetails] = useState(false);

	const onSOLClick = () => {
		agent.Tracking.track(
			`${Static.onSOLClick} ${Static.fromReferenceDeskComponent}`,
			Static.urlVeritasSOL,
		);
	};

	const viewOnGoogleMaps = () => {
		const googleMapsUrl = Static.urlGoogleMaps + sportello.Valore;

		agent.Tracking.track(
			`${Static.onViewOnGoogleMapsClick} ${Static.fromReferenceDeskComponent}`,
			googleMapsUrl,
		);

		window.open(googleMapsUrl, '_blank');
	};

	const toggleDetails = () => {
		agent.Tracking.track(
			`${Static.toggleDetail} ${Static.fromReferenceDeskComponent}`,
		);
		setShowDetails((prev) => !prev);
	};

	return (
		<>
			<div className='card app-card-with-background ps-5 pe-5 pt-3 pb-3 mb-3 d-block d-sm-none'>
				<button
					type='button'
					className='app-toggle-show app-collapse-button'
					onClick={toggleDetails}
					aria-expanded={showDetails}
					aria-controls='reference-desk-detail'
				>
					<h2 className='app-card-title mb-0'>SPORTELLO PIÙ VICINO</h2>
					<i
						className={showDetails ? 'fa fa-angle-up' : 'fa fa-angle-down'}
						style={{ fontSize: '1.5rem' }}
						aria-hidden='true'
					/>
				</button>
			</div>

			<div
				id='reference-desk-detail'
				className={
					showDetails
						? 'card app-card-with-background p-5 d-block d-sm-none'
						: 'd-none'
				}
			>
				{showDetails && (
					<ReferenceDeskBody
						sportello={sportello}
						onSOLClick={onSOLClick}
						viewOnGoogleMaps={viewOnGoogleMaps}
					/>
				)}
			</div>

			<div className='card app-card-with-background p-5 d-none d-sm-block'>
				<h2 className='app-card-title'>SPORTELLO PIÙ VICINO</h2>
				<ReferenceDeskBody
					sportello={sportello}
					onSOLClick={onSOLClick}
					viewOnGoogleMaps={viewOnGoogleMaps}
					firstRowClassName='mt-4'
				/>
			</div>
		</>
	);
};

export default ReferenceDesk;
